import gql from "graphql-tag";

export const REMOVE_CHAT = gql`
  mutation ($chatId: ID!) {
    removeChat(chatId: $chatId) {
      _id
    }
  }
`;
